import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = {
  key: 0,
  class: "form-card"
}
const _hoisted_4 = { class: "form-grid form-grid--single" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = {
  key: 0,
  class: "form-error"
}
const _hoisted_8 = { class: "form-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_11 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_12 = {
  key: 3,
  class: "cards-grid"
}
const _hoisted_13 = {
  key: 0,
  class: "card-link-bar"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "card-title-row" }
const _hoisted_17 = { class: "card-title" }
const _hoisted_18 = {
  key: 0,
  class: "card-desc"
}
const _hoisted_19 = { class: "card-stats" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "card-footer" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_28 = { class: "tab-head" }
const _hoisted_29 = { class: "detail-title-wrap" }
const _hoisted_30 = { class: "tab-title" }
const _hoisted_31 = { class: "head-actions" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "detail-main" }
const _hoisted_34 = { class: "sub-tabs" }
const _hoisted_35 = { class: "sub-tab-count" }
const _hoisted_36 = { class: "sub-tab-count" }
const _hoisted_37 = {
  key: 0,
  class: "pane"
}
const _hoisted_38 = { class: "form-card" }
const _hoisted_39 = { class: "form-grid form-grid--single" }
const _hoisted_40 = { class: "field" }
const _hoisted_41 = { class: "field" }
const _hoisted_42 = { class: "cats-toolbar" }
const _hoisted_43 = { class: "cats-toolbar-actions" }
const _hoisted_44 = ["id"]
const _hoisted_45 = { class: "cat-head" }
const _hoisted_46 = ["title", "onClick"]
const _hoisted_47 = { class: "cat-index" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "cat-chip" }
const _hoisted_50 = {
  key: 0,
  class: "cat-chip cat-chip--accent"
}
const _hoisted_51 = {
  key: 1,
  class: "cat-chip cat-chip--warn"
}
const _hoisted_52 = { class: "cat-tools" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["disabled", "onClick"]
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = { class: "cat-body" }
const _hoisted_58 = { class: "cat-settings" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["max", "onUpdate:modelValue"]
const _hoisted_61 = { class: "field-hint cat-settings-hint" }
const _hoisted_62 = { class: "cat-settings-result" }
const _hoisted_63 = {
  key: 0,
  class: "form-card import-preview"
}
const _hoisted_64 = { class: "form-title" }
const _hoisted_65 = { class: "import-summary" }
const _hoisted_66 = { class: "import-err-count" }
const _hoisted_67 = {
  key: 0,
  class: "import-errors"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 1,
  class: "import-sample"
}
const _hoisted_70 = { class: "import-sample-answer" }
const _hoisted_71 = {
  key: 0,
  class: "import-sample-more"
}
const _hoisted_72 = {
  key: 2,
  class: "import-mode"
}
const _hoisted_73 = { class: "check-row" }
const _hoisted_74 = { class: "check-row" }
const _hoisted_75 = { class: "form-actions" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 1,
  class: "empty-hint empty-hint--compact"
}
const _hoisted_78 = ["id"]
const _hoisted_79 = { class: "q-editor-head" }
const _hoisted_80 = { class: "q-num" }
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = { class: "q-tools" }
const _hoisted_83 = ["disabled", "onClick"]
const _hoisted_84 = ["disabled", "onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "opt-list" }
const _hoisted_88 = ["title"]
const _hoisted_89 = ["name", "checked", "onChange"]
const _hoisted_90 = { class: "opt-letter" }
const _hoisted_91 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_92 = {
  key: 0,
  class: "opt-correct-tag"
}
const _hoisted_93 = ["disabled", "onClick"]
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "save-bar" }
const _hoisted_97 = { class: "save-status" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = {
  key: 1,
  class: "pane"
}
const _hoisted_100 = { class: "form-card" }
const _hoisted_101 = { class: "vis-options" }
const _hoisted_102 = {
  key: 0,
  class: "link-field"
}
const _hoisted_103 = ["value"]
const _hoisted_104 = {
  key: 1,
  class: "field-hint"
}
const _hoisted_105 = { class: "form-card" }
const _hoisted_106 = { class: "table-wrap" }
const _hoisted_107 = { class: "att-table per-cat-table" }
const _hoisted_108 = { class: "per-cat-name" }
const _hoisted_109 = { class: "num" }
const _hoisted_110 = ["onUpdate:modelValue"]
const _hoisted_111 = { class: "num" }
const _hoisted_112 = ["max", "onUpdate:modelValue"]
const _hoisted_113 = {
  key: 1,
  class: "muted"
}
const _hoisted_114 = { class: "num" }
const _hoisted_115 = {
  key: 0,
  class: "per-cat-warn",
  title: "Quantidade maior que o total cadastrado: todas serão usadas"
}
const _hoisted_116 = { class: "row-strong" }
const _hoisted_117 = { class: "num" }
const _hoisted_118 = { colspan: "2" }
const _hoisted_119 = { class: "num" }
const _hoisted_120 = { class: "per-cat-status" }
const _hoisted_121 = { class: "form-card" }
const _hoisted_122 = { class: "check-row" }
const _hoisted_123 = { class: "save-bar" }
const _hoisted_124 = {
  key: 0,
  class: "form-error"
}
const _hoisted_125 = { key: 1 }
const _hoisted_126 = ["disabled"]
const _hoisted_127 = {
  key: 2,
  class: "pane"
}
const _hoisted_128 = { class: "res-toolbar" }
const _hoisted_129 = {
  class: "seg",
  role: "tablist"
}
const _hoisted_130 = { class: "res-filters" }
const _hoisted_131 = { class: "filter" }
const _hoisted_132 = ["max"]
const _hoisted_133 = { class: "filter" }
const _hoisted_134 = ["min"]
const _hoisted_135 = { class: "filter" }
const _hoisted_136 = { value: "shared" }
const _hoisted_137 = ["value"]
const _hoisted_138 = {
  key: 0,
  class: "filter filter--grow"
}
const _hoisted_139 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_140 = {
  key: 1,
  class: "empty-hint empty-hint--compact"
}
const _hoisted_141 = {
  key: 2,
  class: "empty-hint empty-hint--compact"
}
const _hoisted_142 = { class: "stats-row" }
const _hoisted_143 = { class: "stat" }
const _hoisted_144 = { class: "stat-value" }
const _hoisted_145 = { class: "stat" }
const _hoisted_146 = { class: "stat-value" }
const _hoisted_147 = { class: "stat" }
const _hoisted_148 = { class: "stat-value" }
const _hoisted_149 = { class: "stat-value" }
const _hoisted_150 = { class: "donut-grid" }
const _hoisted_151 = ["aria-label"]
const _hoisted_152 = ["r", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_153 = {
  x: "50",
  y: "48",
  "text-anchor": "middle",
  class: "donut-pct"
}
const _hoisted_154 = { class: "donut-name" }
const _hoisted_155 = { class: "donut-meta" }
const _hoisted_156 = { class: "table-wrap" }
const _hoisted_157 = { class: "att-table" }
const _hoisted_158 = { class: "num" }
const _hoisted_159 = { class: "num" }
const _hoisted_160 = { class: "num" }
const _hoisted_161 = { class: "num" }
const _hoisted_162 = { class: "num" }
const _hoisted_163 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_164 = { class: "att-table" }
const _hoisted_165 = ["onClick"]
const _hoisted_166 = ["title", "onClick"]
const _hoisted_167 = {
  key: 1,
  class: "muted"
}
const _hoisted_168 = { class: "src-chip" }
const _hoisted_169 = { class: "num" }
const _hoisted_170 = { class: "num" }
const _hoisted_171 = {
  key: 0,
  class: "att-detail-row"
}
const _hoisted_172 = { colspan: "6" }
const _hoisted_173 = {
  key: 0,
  class: "shared-note"
}
const _hoisted_174 = {
  key: 1,
  class: "att-cats"
}
const _hoisted_175 = { class: "muted" }
const _hoisted_176 = {
  key: 2,
  class: "detail-loading"
}
const _hoisted_177 = {
  key: 0,
  class: "att-group-title"
}
const _hoisted_178 = { class: "att-answers" }
const _hoisted_179 = { class: "att-q" }
const _hoisted_180 = { class: "att-a" }
const _hoisted_181 = { class: "att-mark" }
const _hoisted_182 = {
  key: 0,
  class: "detail-aside"
}
const _hoisted_183 = { class: "aside-card aside-hero" }
const _hoisted_184 = { class: "aside-title" }
const _hoisted_185 = {
  key: 0,
  class: "aside-desc"
}
const _hoisted_186 = { class: "aside-chips" }
const _hoisted_187 = { class: "aside-chip" }
const _hoisted_188 = { class: "aside-card" }
const _hoisted_189 = { class: "aside-metrics" }
const _hoisted_190 = { class: "aside-metric" }
const _hoisted_191 = { class: "aside-metric-value" }
const _hoisted_192 = { class: "aside-metric-label" }
const _hoisted_193 = { class: "aside-metric" }
const _hoisted_194 = { class: "aside-metric-value" }
const _hoisted_195 = { class: "aside-metric-label" }
const _hoisted_196 = { class: "aside-metric" }
const _hoisted_197 = { class: "aside-metric-value" }
const _hoisted_198 = { class: "aside-metric-label" }
const _hoisted_199 = { class: "aside-metric" }
const _hoisted_200 = { class: "aside-metric-value" }
const _hoisted_201 = {
  key: 0,
  class: "aside-completeness"
}
const _hoisted_202 = { class: "aside-completeness-head" }
const _hoisted_203 = { class: "aside-bar" }
const _hoisted_204 = {
  key: 0,
  class: "aside-card"
}
const _hoisted_205 = { class: "q-nav-groups" }
const _hoisted_206 = ["onClick"]
const _hoisted_207 = {
  key: 0,
  class: "q-nav"
}
const _hoisted_208 = ["title", "onClick"]
const _hoisted_209 = {
  key: 1,
  class: "q-nav-empty"
}
const _hoisted_210 = { class: "aside-card aside-status" }
const _hoisted_211 = { class: "aside-status-row" }
const _hoisted_212 = {
  key: 0,
  class: "aside-status-row aside-status-row--action"
}
const _hoisted_213 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_214 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_215 = {
  key: 2,
  class: "take-wrap"
}
const _hoisted_216 = { class: "take-head" }
const _hoisted_217 = { class: "tab-title" }
const _hoisted_218 = {
  key: 0,
  class: "tab-sub take-desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizRunner = _resolveComponent("QuizRunner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.view === 'list')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[41] || (_cache[41] = _createElementVNode("div", null, [
              _createElementVNode("h2", { class: "tab-title" }, "Questionários"),
              _createElementVNode("p", { class: "tab-sub" }, "Provas de múltipla escolha para treinamento e avaliação.")
            ], -1)),
            (!_ctx.showCreate)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-primary",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
                }, [...(_cache[40] || (_cache[40] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.2"
                  }, [
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "5",
                      x2: "12",
                      y2: "19"
                    }),
                    _createElementVNode("line", {
                      x1: "5",
                      y1: "12",
                      x2: "19",
                      y2: "12"
                    })
                  ], -1),
                  _createTextVNode(" Novo questionário ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "form-title" }, "Novo questionário", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, [
                    _cache[42] || (_cache[42] = _createElementVNode("span", { class: "field-label" }, "Título *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      ref: "createTitleRef",
                      class: "field-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createForm.title) = $event)),
                      maxlength: "200",
                      placeholder: "Ex: NR-35 — Trabalho em altura",
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.createForm.title]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_6, [
                    _cache[43] || (_cache[43] = _createElementVNode("span", { class: "field-label" }, "Descrição", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "field-input field-textarea",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createForm.description) = $event)),
                      rows: "2",
                      placeholder: "Instruções exibidas antes de começar a prova"
                    }, null, 512), [
                      [_vModelText, _ctx.createForm.description]
                    ])
                  ])
                ]),
                (_ctx.createError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.createError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btn-save",
                    type: "button",
                    disabled: _ctx.creating,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
                  }, _toDisplayString(_ctx.creating ? 'Criando...' : 'Criar e adicionar perguntas'), 9, _hoisted_9),
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCreate = false))
                  }, "Cancelar")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Carregando..."))
            : (_ctx.quizzes.length === 0 && !_ctx.showCreate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[45] || (_cache[45] = [
                  _createElementVNode("svg", {
                    width: "36",
                    height: "36",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.4"
                  }, [
                    _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
                    _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
                  ], -1),
                  _createTextVNode(" Nenhum questionário criado. ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizzes, (q) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: q.id,
                      class: "quiz-card"
                    }, [
                      (q.visibility === 'public' && q.publicHash)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _cache[47] || (_cache[47] = _createStaticVNode("<svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-eb73ab54><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-eb73ab54></circle><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\" data-v-eb73ab54></line><path d=\"M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\" data-v-eb73ab54></path></svg><span class=\"card-link-label\" data-v-eb73ab54>Link público ativo</span>", 2)),
                            _createElementVNode("button", {
                              class: "copy-link-btn",
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.copyLink(q.publicHash)), ["stop"])
                            }, [
                              _cache[46] || (_cache[46] = _createElementVNode("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2"
                              }, [
                                _createElementVNode("rect", {
                                  x: "9",
                                  y: "9",
                                  width: "13",
                                  height: "13",
                                  rx: "2"
                                }),
                                _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.copiedHash === q.publicHash ? 'Copiado!' : 'Copiar link'), 1)
                            ], 8, _hoisted_14)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "card-body",
                        onClick: ($event: any) => (_ctx.openQuiz(q.id))
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(q.title), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["vis-chip", q.visibility === 'public' ? 'vis-chip--public' : 'vis-chip--private'])
                          }, _toDisplayString(q.visibility === 'public' ? 'Público' : 'Fechado'), 3)
                        ]),
                        (q.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(q.description), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString(q.totalQuestions) + " pergunta" + _toDisplayString(q.totalQuestions === 1 ? '' : 's'), 1),
                          (q.categoriesCount > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "· " + _toDisplayString(q.categoriesCount) + " categorias", 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, "· " + _toDisplayString(q.attemptsCount) + " tentativa" + _toDisplayString(q.attemptsCount === 1 ? '' : 's'), 1),
                          (q.avgScore !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "· média " + _toDisplayString(_ctx.formatPct(q.avgScore)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_15),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          class: "card-btn",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openQuiz(q.id))
                        }, "Editar", 8, _hoisted_23),
                        _createElementVNode("button", {
                          class: "card-btn",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openQuiz(q.id, 'resultados'))
                        }, "Resultados", 8, _hoisted_24),
                        _createElementVNode("button", {
                          class: "card-btn",
                          type: "button",
                          disabled: q.totalQuestions === 0,
                          onClick: ($event: any) => (_ctx.startTake(q.id))
                        }, "Responder", 8, _hoisted_25),
                        _createElementVNode("button", {
                          class: "card-btn card-btn--warn",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeQuiz(q))
                        }, "Excluir", 8, _hoisted_26)
                      ])
                    ]))
                  }), 128))
                ]))
        ], 64))
      : (_ctx.view === 'detail')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              class: "back-link",
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [...(_cache[48] || (_cache[48] = [
              _createElementVNode("svg", {
                width: "12",
                height: "12",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.4"
              }, [
                _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
              ], -1),
              _createTextVNode(" Questionários ", -1)
            ]))]),
            (_ctx.detailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Carregando..."))
              : (_ctx.detail)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.editForm.title || 'Sem título'), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["vis-chip", _ctx.detail.visibility === 'public' ? 'vis-chip--public' : 'vis-chip--private'])
                        }, _toDisplayString(_ctx.detail.visibility === 'public' ? 'Público' : 'Fechado à organização'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.detail.visibility === 'public' && _ctx.detail.publicHash)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn-secondary",
                              type: "button",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copyLink(_ctx.detail.publicHash)))
                            }, _toDisplayString(_ctx.copiedHash === _ctx.detail.publicHash ? 'Copiado!' : 'Copiar link'), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn-secondary",
                          type: "button",
                          disabled: _ctx.totalQuestions === 0,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startTake(_ctx.detail.id)))
                        }, "Responder", 8, _hoisted_32)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["detail-layout", { 'detail-layout--wide': _ctx.detailTab === 'resultados' }])
                    }, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["sub-tab", { active: _ctx.detailTab === 'perguntas' }]),
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detailTab = 'perguntas'))
                          }, [
                            _cache[49] || (_cache[49] = _createTextVNode(" Perguntas ", -1)),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.totalQuestions), 1)
                          ], 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["sub-tab", { active: _ctx.detailTab === 'config' }]),
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailTab = 'config'))
                          }, "Configurações", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["sub-tab", { active: _ctx.detailTab === 'resultados' }]),
                            type: "button",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openResults && _ctx.openResults(...args)))
                          }, [
                            _cache[50] || (_cache[50] = _createTextVNode(" Resultados ", -1)),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.attempts.length || ''), 1)
                          ], 2)
                        ]),
                        (_ctx.detailTab === 'perguntas')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("label", _hoisted_40, [
                                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "field-label" }, "Título *", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      class: "field-input",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editForm.title) = $event)),
                                      maxlength: "200"
                                    }, null, 512), [
                                      [_vModelText, _ctx.editForm.title]
                                    ])
                                  ]),
                                  _createElementVNode("label", _hoisted_41, [
                                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "field-label" }, "Descrição", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                      class: "field-input field-textarea",
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editForm.description) = $event)),
                                      rows: "2",
                                      placeholder: "Instruções exibidas antes de começar a prova"
                                    }, null, 512), [
                                      [_vModelText, _ctx.editForm.description]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "cats-toolbar-text" }, [
                                  _createElementVNode("strong", null, "Categorias"),
                                  _createElementVNode("span", null, "Quem responde passa por uma categoria de cada vez, na ordem abaixo.")
                                ], -1)),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("button", {
                                    class: "btn-link",
                                    type: "button",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setAllCollapsed(false)))
                                  }, "Expandir todas"),
                                  _createElementVNode("button", {
                                    class: "btn-link",
                                    type: "button",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setAllCollapsed(true)))
                                  }, "Recolher todas"),
                                  _createElementVNode("button", {
                                    class: "btn-link",
                                    type: "button",
                                    title: "Planilha de exemplo para importar perguntas",
                                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.downloadTemplate && _ctx.downloadTemplate(...args)))
                                  }, "Modelo Excel")
                                ])
                              ]),
                              _createElementVNode("input", {
                                ref: "importInputRef",
                                type: "file",
                                accept: ".xlsx,.xls,.csv",
                                hidden: "",
                                onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onImportFile && _ctx.onImportFile(...args)))
                              }, null, 544),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.categories, (cat, ci) => {
                                return (_openBlock(), _createElementBlock("section", {
                                  key: cat.key,
                                  id: 'qcat-' + cat.key,
                                  class: _normalizeClass(["cat-block", { 'cat-block--collapsed': cat.collapsed }])
                                }, [
                                  _createElementVNode("header", _hoisted_45, [
                                    _createElementVNode("button", {
                                      class: "cat-toggle",
                                      type: "button",
                                      title: cat.collapsed ? 'Expandir' : 'Recolher',
                                      onClick: ($event: any) => (cat.collapsed = !cat.collapsed)
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(["cat-chevron", { open: !cat.collapsed }]),
                                        width: "13",
                                        height: "13",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.6"
                                      }, [...(_cache[54] || (_cache[54] = [
                                        _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                                      ]))], 2))
                                    ], 8, _hoisted_46),
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(ci + 1), 1),
                                    _withDirectives(_createElementVNode("input", {
                                      class: "cat-name-input",
                                      "onUpdate:modelValue": ($event: any) => ((cat.name) = $event),
                                      maxlength: "120",
                                      placeholder: "Nome da categoria"
                                    }, null, 8, _hoisted_48), [
                                      [_vModelText, cat.name]
                                    ]),
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(cat.questions.length) + " pergunta" + _toDisplayString(cat.questions.length === 1 ? '' : 's'), 1),
                                    (cat.mode !== 'all' && cat.questionCount > 0 && cat.questionCount < cat.questions.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(cat.mode === 'first' ? `${cat.questionCount} primeiras` : `sorteia ${cat.questionCount}`), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.pendingInCategory(cat))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.pendingInCategory(cat)) + " pendente" + _toDisplayString(_ctx.pendingInCategory(cat) === 1 ? '' : 's'), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("button", {
                                        class: "cat-import-btn",
                                        type: "button",
                                        title: "Importar perguntas do Excel para esta categoria",
                                        onClick: ($event: any) => (_ctx.pickImportFile(cat.key))
                                      }, [...(_cache[55] || (_cache[55] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2"
                                        }, [
                                          _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                          _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
                                          _createElementVNode("line", {
                                            x1: "12",
                                            y1: "3",
                                            x2: "12",
                                            y2: "15"
                                          })
                                        ], -1),
                                        _createTextVNode(" Importar ", -1)
                                      ]))], 8, _hoisted_53),
                                      _createElementVNode("button", {
                                        class: "icon-btn",
                                        type: "button",
                                        title: "Mover categoria para cima",
                                        disabled: ci === 0,
                                        onClick: ($event: any) => (_ctx.moveCategory(ci, -1))
                                      }, [...(_cache[56] || (_cache[56] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.2"
                                        }, [
                                          _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                                        ], -1)
                                      ]))], 8, _hoisted_54),
                                      _createElementVNode("button", {
                                        class: "icon-btn",
                                        type: "button",
                                        title: "Mover categoria para baixo",
                                        disabled: ci === _ctx.editForm.categories.length - 1,
                                        onClick: ($event: any) => (_ctx.moveCategory(ci, 1))
                                      }, [...(_cache[57] || (_cache[57] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.2"
                                        }, [
                                          _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                        ], -1)
                                      ]))], 8, _hoisted_55),
                                      _createElementVNode("button", {
                                        class: "icon-btn icon-btn--warn",
                                        type: "button",
                                        title: "Excluir categoria",
                                        disabled: _ctx.editForm.categories.length <= 1,
                                        onClick: ($event: any) => (_ctx.removeCategory(ci))
                                      }, [...(_cache[58] || (_cache[58] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2"
                                        }, [
                                          _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                                          _createElementVNode("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
                                          _createElementVNode("path", { d: "M10 11v6M14 11v6" })
                                        ], -1)
                                      ]))], 8, _hoisted_56)
                                    ])
                                  ]),
                                  _withDirectives(_createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, [
                                      _cache[60] || (_cache[60] = _createElementVNode("span", { class: "cat-settings-label" }, "Por tentativa:", -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        class: "field-input mode-select",
                                        "onUpdate:modelValue": ($event: any) => ((cat.mode) = $event)
                                      }, [...(_cache[59] || (_cache[59] = [
                                        _createElementVNode("option", { value: "all" }, "Todas as perguntas", -1),
                                        _createElementVNode("option", { value: "random" }, "Sortear uma quantidade", -1),
                                        _createElementVNode("option", { value: "first" }, "As primeiras (na ordem)", -1)
                                      ]))], 8, _hoisted_59), [
                                        [_vModelSelect, cat.mode]
                                      ]),
                                      (cat.mode !== 'all')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "field-input count-input",
                                              type: "number",
                                              min: "1",
                                              max: cat.questions.length || undefined,
                                              "onUpdate:modelValue": ($event: any) => ((cat.questionCount) = $event)
                                            }, null, 8, _hoisted_60), [
                                              [
                                                _vModelText,
                                                cat.questionCount,
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _createElementVNode("span", _hoisted_61, "de " + _toDisplayString(cat.questions.length), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_62, "→ " + _toDisplayString(_ctx.effectiveCount(cat)) + " aparece" + _toDisplayString(_ctx.effectiveCount(cat) === 1 ? '' : 'm') + " por tentativa", 1)
                                    ]),
                                    (_ctx.importPreview && _ctx.importPreview.categoryKey === cat.key)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _createElementVNode("h3", _hoisted_64, "Importar \"" + _toDisplayString(_ctx.importPreview.fileName) + "\" em " + _toDisplayString(cat.name || 'esta categoria'), 1),
                                          _createElementVNode("p", _hoisted_65, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.importPreview.questions.length), 1),
                                            _createTextVNode(" pergunta" + _toDisplayString(_ctx.importPreview.questions.length === 1 ? '' : 's') + " válida" + _toDisplayString(_ctx.importPreview.questions.length === 1 ? '' : 's') + " ", 1),
                                            (_ctx.importPreview.errors.length)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _cache[61] || (_cache[61] = _createTextVNode(" · ", -1)),
                                                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.importPreview.errors.length) + " linha" + _toDisplayString(_ctx.importPreview.errors.length === 1 ? '' : 's') + " com erro (serão ignoradas)", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (_ctx.importPreview.skippedHeader)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode(" · linha 1 tratada como cabeçalho")
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.importPreview.errors.length)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_67, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importPreview.errors.slice(0, 8), (err) => {
                                                  return (_openBlock(), _createElementBlock("li", {
                                                    key: err.row
                                                  }, "Linha " + _toDisplayString(err.row) + ": " + _toDisplayString(err.message), 1))
                                                }), 128)),
                                                (_ctx.importPreview.errors.length > 8)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_68, "… e mais " + _toDisplayString(_ctx.importPreview.errors.length - 8), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.importPreview.questions.length)
                                            ? (_openBlock(), _createElementBlock("ol", _hoisted_69, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importPreview.questions.slice(0, 3), (q, i) => {
                                                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                                                    _createTextVNode(_toDisplayString(q.text) + " ", 1),
                                                    _createElementVNode("span", _hoisted_70, "→ " + _toDisplayString(_ctx.letter(q.correctIndex)) + ") " + _toDisplayString(q.options[q.correctIndex]), 1)
                                                  ]))
                                                }), 128)),
                                                (_ctx.importPreview.questions.length > 3)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_71, "… e mais " + _toDisplayString(_ctx.importPreview.questions.length - 3), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.filledQuestions(cat).length && _ctx.importPreview.questions.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                _createElementVNode("label", _hoisted_73, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: "append",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.importMode) = $event))
                                                  }, null, 512), [
                                                    [_vModelRadio, _ctx.importMode]
                                                  ]),
                                                  _cache[62] || (_cache[62] = _createTextVNode()),
                                                  _createElementVNode("span", null, "Adicionar às " + _toDisplayString(_ctx.filledQuestions(cat).length) + " perguntas desta categoria", 1)
                                                ]),
                                                _createElementVNode("label", _hoisted_74, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: "replace",
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.importMode) = $event))
                                                  }, null, 512), [
                                                    [_vModelRadio, _ctx.importMode]
                                                  ]),
                                                  _cache[63] || (_cache[63] = _createTextVNode()),
                                                  _cache[64] || (_cache[64] = _createElementVNode("span", null, "Substituir as perguntas desta categoria", -1))
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("button", {
                                              class: "btn-save",
                                              type: "button",
                                              disabled: !_ctx.importPreview.questions.length,
                                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.applyImport && _ctx.applyImport(...args)))
                                            }, " Importar " + _toDisplayString(_ctx.importPreview.questions.length) + " pergunta" + _toDisplayString(_ctx.importPreview.questions.length === 1 ? '' : 's'), 9, _hoisted_76),
                                            _createElementVNode("button", {
                                              class: "btn-cancel",
                                              type: "button",
                                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.importPreview = null))
                                            }, "Cancelar")
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (cat.questions.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Nenhuma pergunta nesta categoria. Adicione abaixo ou use \"Importar\". "))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.questions, (q, qi) => {
                                      return (_openBlock(), _createElementBlock("article", {
                                        key: q.key,
                                        id: 'qe-' + q.key,
                                        class: _normalizeClass(["q-editor", { 'q-editor--flash': _ctx.flashKey === q.key }])
                                      }, [
                                        _createElementVNode("div", _hoisted_79, [
                                          _createElementVNode("span", _hoisted_80, _toDisplayString(qi + 1), 1),
                                          _withDirectives(_createElementVNode("textarea", {
                                            class: "field-input field-textarea q-text",
                                            "onUpdate:modelValue": ($event: any) => ((q.text) = $event),
                                            rows: "2",
                                            placeholder: "Enunciado da pergunta"
                                          }, null, 8, _hoisted_81), [
                                            [_vModelText, q.text]
                                          ]),
                                          _createElementVNode("div", _hoisted_82, [
                                            _createElementVNode("button", {
                                              class: "icon-btn",
                                              type: "button",
                                              title: "Mover para cima",
                                              disabled: qi === 0,
                                              onClick: ($event: any) => (_ctx.moveQuestion(cat, qi, -1))
                                            }, [...(_cache[65] || (_cache[65] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2.2"
                                              }, [
                                                _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                                              ], -1)
                                            ]))], 8, _hoisted_83),
                                            _createElementVNode("button", {
                                              class: "icon-btn",
                                              type: "button",
                                              title: "Mover para baixo",
                                              disabled: qi === cat.questions.length - 1,
                                              onClick: ($event: any) => (_ctx.moveQuestion(cat, qi, 1))
                                            }, [...(_cache[66] || (_cache[66] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2.2"
                                              }, [
                                                _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                              ], -1)
                                            ]))], 8, _hoisted_84),
                                            _createElementVNode("button", {
                                              class: "icon-btn",
                                              type: "button",
                                              title: "Duplicar",
                                              onClick: ($event: any) => (_ctx.duplicateQuestion(cat, qi))
                                            }, [...(_cache[67] || (_cache[67] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                              }, [
                                                _createElementVNode("rect", {
                                                  x: "9",
                                                  y: "9",
                                                  width: "13",
                                                  height: "13",
                                                  rx: "2"
                                                }),
                                                _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
                                              ], -1)
                                            ]))], 8, _hoisted_85),
                                            _createElementVNode("button", {
                                              class: "icon-btn icon-btn--warn",
                                              type: "button",
                                              title: "Remover pergunta",
                                              onClick: ($event: any) => (_ctx.removeQuestion(cat, qi))
                                            }, [...(_cache[68] || (_cache[68] = [
                                              _createElementVNode("svg", {
                                                width: "13",
                                                height: "13",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2"
                                              }, [
                                                _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                                                _createElementVNode("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
                                                _createElementVNode("path", { d: "M10 11v6M14 11v6" })
                                              ], -1)
                                            ]))], 8, _hoisted_86)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_87, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (_opt, oi) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: oi,
                                              class: _normalizeClass(["opt-row", { 'opt-row--correct': q.correctIndex === oi }])
                                            }, [
                                              _createElementVNode("label", {
                                                class: "opt-correct",
                                                title: q.correctIndex === oi ? 'Alternativa correta' : 'Marcar como correta'
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "radio",
                                                  name: 'correct-' + q.key,
                                                  checked: q.correctIndex === oi,
                                                  onChange: ($event: any) => (q.correctIndex = oi)
                                                }, null, 40, _hoisted_89),
                                                _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.letter(oi)), 1)
                                              ], 8, _hoisted_88),
                                              _withDirectives(_createElementVNode("input", {
                                                class: "field-input opt-input",
                                                "onUpdate:modelValue": ($event: any) => ((q.options[oi]) = $event),
                                                placeholder: 'Alternativa ' + _ctx.letter(oi)
                                              }, null, 8, _hoisted_91), [
                                                [_vModelText, q.options[oi]]
                                              ]),
                                              (q.correctIndex === oi)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Correta"))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                class: "icon-btn icon-btn--warn",
                                                type: "button",
                                                title: "Remover alternativa",
                                                disabled: q.options.length <= 2,
                                                onClick: ($event: any) => (_ctx.removeOption(q, oi))
                                              }, [...(_cache[69] || (_cache[69] = [
                                                _createElementVNode("svg", {
                                                  width: "12",
                                                  height: "12",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2.2"
                                                }, [
                                                  _createElementVNode("line", {
                                                    x1: "18",
                                                    y1: "6",
                                                    x2: "6",
                                                    y2: "18"
                                                  }),
                                                  _createElementVNode("line", {
                                                    x1: "6",
                                                    y1: "6",
                                                    x2: "18",
                                                    y2: "18"
                                                  })
                                                ], -1)
                                              ]))], 8, _hoisted_93)
                                            ], 2))
                                          }), 128)),
                                          (q.options.length < 10)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "add-opt-btn",
                                                type: "button",
                                                onClick: ($event: any) => (q.options.push(''))
                                              }, "+ Alternativa", 8, _hoisted_94))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, _hoisted_78))
                                    }), 128)),
                                    _createElementVNode("button", {
                                      class: "add-q-btn add-q-btn--small",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.addQuestion(cat))
                                    }, [
                                      _cache[70] || (_cache[70] = _createElementVNode("svg", {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.2"
                                      }, [
                                        _createElementVNode("line", {
                                          x1: "12",
                                          y1: "5",
                                          x2: "12",
                                          y2: "19"
                                        }),
                                        _createElementVNode("line", {
                                          x1: "5",
                                          y1: "12",
                                          x2: "19",
                                          y2: "12"
                                        })
                                      ], -1)),
                                      _createTextVNode(" Adicionar pergunta em " + _toDisplayString(cat.name || 'esta categoria'), 1)
                                    ], 8, _hoisted_95)
                                  ], 512), [
                                    [_vShow, !cat.collapsed]
                                  ])
                                ], 10, _hoisted_44))
                              }), 128)),
                              _createElementVNode("button", {
                                class: "add-q-btn",
                                type: "button",
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addCategory && _ctx.addCategory(...args)))
                              }, [...(_cache[71] || (_cache[71] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.2"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "5",
                                    x2: "12",
                                    y2: "19"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "5",
                                    y1: "12",
                                    x2: "19",
                                    y2: "12"
                                  })
                                ], -1),
                                _createTextVNode(" Nova categoria ", -1)
                              ]))]),
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["status-dot", 'status-dot--' + _ctx.saveState])
                                  }, null, 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["save-status-text", { 'save-status-text--err': _ctx.saveState === 'error' }])
                                  }, _toDisplayString(_ctx.saveStatusText), 3)
                                ]),
                                _createElementVNode("button", {
                                  class: "btn-save",
                                  type: "button",
                                  disabled: _ctx.saving,
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.saveQuestions()))
                                }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar perguntas'), 9, _hoisted_98)
                              ])
                            ]))
                          : (_ctx.detailTab === 'config')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createElementVNode("section", _hoisted_100, [
                                  _cache[74] || (_cache[74] = _createElementVNode("h3", { class: "form-title" }, "Acesso", -1)),
                                  _createElementVNode("div", _hoisted_101, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["vis-option", { active: _ctx.settings.visibility === 'private' }])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        value: "private",
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.settings.visibility) = $event))
                                      }, null, 512), [
                                        [_vModelRadio, _ctx.settings.visibility]
                                      ]),
                                      _cache[72] || (_cache[72] = _createElementVNode("div", null, [
                                        _createElementVNode("div", { class: "vis-option-title" }, "Fechado à organização"),
                                        _createElementVNode("div", { class: "vis-option-desc" }, "Só usuários logados no sistema conseguem responder, pelo botão \"Responder\".")
                                      ], -1))
                                    ], 2),
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["vis-option", { active: _ctx.settings.visibility === 'public' }])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        value: "public",
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.settings.visibility) = $event))
                                      }, null, 512), [
                                        [_vModelRadio, _ctx.settings.visibility]
                                      ]),
                                      _cache[73] || (_cache[73] = _createElementVNode("div", null, [
                                        _createElementVNode("div", { class: "vis-option-title" }, "Público"),
                                        _createElementVNode("div", { class: "vis-option-desc" }, "Gera um link para qualquer pessoa responder informando um nome de usuário.")
                                      ], -1))
                                    ], 2)
                                  ]),
                                  (_ctx.detail.visibility === 'public' && _ctx.detail.publicHash)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                        _createElementVNode("input", {
                                          class: "field-input",
                                          value: _ctx.buildLink(_ctx.detail.publicHash),
                                          readonly: "",
                                          onFocus: _cache[26] || (_cache[26] = ($event: any) => (($event.target as HTMLInputElement).select()))
                                        }, null, 40, _hoisted_103),
                                        _createElementVNode("button", {
                                          class: "btn-secondary",
                                          type: "button",
                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.copyLink(_ctx.detail.publicHash)))
                                        }, _toDisplayString(_ctx.copiedHash === _ctx.detail.publicHash ? 'Copiado!' : 'Copiar link'), 1)
                                      ]))
                                    : (_ctx.settings.visibility === 'public')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_104, "O link será gerado ao salvar."))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("section", _hoisted_105, [
                                  _cache[78] || (_cache[78] = _createElementVNode("h3", { class: "form-title" }, "Perguntas por tentativa", -1)),
                                  _cache[79] || (_cache[79] = _createElementVNode("p", { class: "field-hint field-hint--flush per-cat-intro" }, " Defina, para cada categoria, quantas perguntas aparecem em cada tentativa e como elas são escolhidas. Salvo automaticamente junto com as perguntas. ", -1)),
                                  _createElementVNode("div", _hoisted_106, [
                                    _createElementVNode("table", _hoisted_107, [
                                      _cache[77] || (_cache[77] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "Categoria"),
                                          _createElementVNode("th", { class: "num" }, "Cadastradas"),
                                          _createElementVNode("th", null, "Como escolher"),
                                          _createElementVNode("th", { class: "num" }, "Quantidade"),
                                          _createElementVNode("th", { class: "num" }, "Por tentativa")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.categories, (cat) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: cat.key,
                                            class: _normalizeClass({ 'row-muted': !cat.questions.length })
                                          }, [
                                            _createElementVNode("td", _hoisted_108, _toDisplayString(cat.name || 'Sem nome'), 1),
                                            _createElementVNode("td", _hoisted_109, _toDisplayString(cat.questions.length), 1),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("select", {
                                                class: "field-input mode-select",
                                                "onUpdate:modelValue": ($event: any) => ((cat.mode) = $event)
                                              }, [...(_cache[75] || (_cache[75] = [
                                                _createElementVNode("option", { value: "all" }, "Todas", -1),
                                                _createElementVNode("option", { value: "random" }, "Sortear", -1),
                                                _createElementVNode("option", { value: "first" }, "As primeiras", -1)
                                              ]))], 8, _hoisted_110), [
                                                [_vModelSelect, cat.mode]
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_111, [
                                              (cat.mode !== 'all')
                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    class: "field-input count-input",
                                                    type: "number",
                                                    min: "1",
                                                    max: cat.questions.length || undefined,
                                                    "onUpdate:modelValue": ($event: any) => ((cat.questionCount) = $event)
                                                  }, null, 8, _hoisted_112)), [
                                                    [
                                                      _vModelText,
                                                      cat.questionCount,
                                                      void 0,
                                                      { number: true }
                                                    ]
                                                  ])
                                                : (_openBlock(), _createElementBlock("span", _hoisted_113, "—"))
                                            ]),
                                            _createElementVNode("td", _hoisted_114, [
                                              _createElementVNode("strong", null, _toDisplayString(_ctx.effectiveCount(cat)), 1),
                                              (cat.mode !== 'all' && cat.questionCount > cat.questions.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_115, "!"))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 2))
                                        }), 128))
                                      ]),
                                      _createElementVNode("tfoot", null, [
                                        _createElementVNode("tr", _hoisted_116, [
                                          _cache[76] || (_cache[76] = _createElementVNode("td", null, "Total", -1)),
                                          _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.totalQuestions), 1),
                                          _createElementVNode("td", _hoisted_118, _toDisplayString(_ctx.answerableCategories) + " etapa" + _toDisplayString(_ctx.answerableCategories === 1 ? '' : 's'), 1),
                                          _createElementVNode("td", _hoisted_119, _toDisplayString(_ctx.perAttemptCount), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_120, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["status-dot", 'status-dot--' + _ctx.saveState])
                                    }, null, 2),
                                    _createElementVNode("span", {
                                      class: _normalizeClass({ 'save-status-text--err': _ctx.saveState === 'error' })
                                    }, _toDisplayString(_ctx.saveStatusText), 3)
                                  ])
                                ]),
                                _createElementVNode("section", _hoisted_121, [
                                  _cache[81] || (_cache[81] = _createElementVNode("h3", { class: "form-title" }, "Após o envio", -1)),
                                  _createElementVNode("label", _hoisted_122, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.settings.showAnswersAfterSubmit) = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.settings.showAnswersAfterSubmit]
                                    ]),
                                    _cache[80] || (_cache[80] = _createElementVNode("span", null, "Mostrar o gabarito (resposta correta) no resumo", -1))
                                  ]),
                                  _cache[82] || (_cache[82] = _createElementVNode("p", { class: "field-hint" }, "Desligado: o participante vê só quais acertou e quais errou, sem a resposta certa — útil se ele puder tentar de novo.", -1))
                                ]),
                                _createElementVNode("div", _hoisted_123, [
                                  (_ctx.settingsError)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_124, _toDisplayString(_ctx.settingsError), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_125)),
                                  _createElementVNode("button", {
                                    class: "btn-save",
                                    type: "button",
                                    disabled: _ctx.savingSettings,
                                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
                                  }, _toDisplayString(_ctx.savingSettings ? 'Salvando...' : 'Salvar configurações'), 9, _hoisted_126)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                _createElementVNode("div", _hoisted_128, [
                                  _createElementVNode("div", _hoisted_129, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["seg-btn", { active: _ctx.resultsView === 'summary' }]),
                                      type: "button",
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.resultsView = 'summary'))
                                    }, "Relatório resumido", 2),
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["seg-btn", { active: _ctx.resultsView === 'individual' }]),
                                      type: "button",
                                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.resultsView = 'individual'))
                                    }, "Resultados individuais", 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_130, [
                                    _createElementVNode("label", _hoisted_131, [
                                      _cache[83] || (_cache[83] = _createElementVNode("span", { class: "filter-label" }, "De", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        class: "field-input filter-input",
                                        type: "date",
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.filters.from) = $event)),
                                        max: _ctx.filters.to || undefined
                                      }, null, 8, _hoisted_132), [
                                        [_vModelText, _ctx.filters.from]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_133, [
                                      _cache[84] || (_cache[84] = _createElementVNode("span", { class: "filter-label" }, "Até", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        class: "field-input filter-input",
                                        type: "date",
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.filters.to) = $event)),
                                        min: _ctx.filters.from || undefined
                                      }, null, 8, _hoisted_134), [
                                        [_vModelText, _ctx.filters.to]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_135, [
                                      _cache[86] || (_cache[86] = _createElementVNode("span", { class: "filter-label" }, "Dispositivo", -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        class: "field-input filter-input",
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.filters.device) = $event))
                                      }, [
                                        _cache[85] || (_cache[85] = _createElementVNode("option", { value: "all" }, "Todos", -1)),
                                        _createElementVNode("option", _hoisted_136, "Só compartilhados (" + _toDisplayString(_ctx.sharedDeviceIds.size) + ")", 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (d) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: d.id,
                                            value: d.id
                                          }, _toDisplayString(d.label) + " — " + _toDisplayString(d.names), 9, _hoisted_137))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _ctx.filters.device]
                                      ])
                                    ]),
                                    (_ctx.resultsView === 'individual')
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_138, [
                                          _cache[87] || (_cache[87] = _createElementVNode("span", { class: "filter-label" }, "Usuário", -1)),
                                          _withDirectives(_createElementVNode("input", {
                                            class: "field-input filter-input",
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.filters.search) = $event)),
                                            placeholder: "Buscar nome"
                                          }, null, 512), [
                                            [_vModelText, _ctx.filters.search]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.filtersActive)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btn-link filter-clear",
                                          type: "button",
                                          onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                                        }, "Limpar filtros"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.attemptsLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, "Carregando..."))
                                  : (_ctx.attempts.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, "Nenhuma tentativa enviada ainda."))
                                    : (_ctx.filteredAttempts.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_141, "Nenhuma tentativa no filtro selecionado."))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createElementVNode("div", _hoisted_142, [
                                            _createElementVNode("div", _hoisted_143, [
                                              _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.filteredAttempts.length), 1),
                                              _cache[88] || (_cache[88] = _createElementVNode("span", { class: "stat-label" }, "Tentativas", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_145, [
                                              _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.uniqueParticipants), 1),
                                              _cache[89] || (_cache[89] = _createElementVNode("span", { class: "stat-label" }, "Participantes", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_147, [
                                              _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.formatPct(_ctx.avgScore)), 1),
                                              _cache[90] || (_cache[90] = _createElementVNode("span", { class: "stat-label" }, "Média geral", -1))
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["stat", { 'stat--warn': _ctx.sharedInFilter > 0 }])
                                            }, [
                                              _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.sharedInFilter), 1),
                                              _cache[91] || (_cache[91] = _createElementVNode("span", { class: "stat-label" }, "Dispositivos com +1 nome", -1))
                                            ], 2)
                                          ]),
                                          (_ctx.resultsView === 'summary')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("div", _hoisted_150, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donutItems, (item) => {
                                                    return (_openBlock(), _createElementBlock("figure", {
                                                      key: item.key,
                                                      class: _normalizeClass(["donut-card", { 'donut-card--overall': item.overall }])
                                                    }, [
                                                      (_openBlock(), _createElementBlock("svg", {
                                                        class: "donut",
                                                        viewBox: "0 0 100 100",
                                                        role: "img",
                                                        "aria-label": `${item.name}: média de ${_ctx.formatPct(item.avg)} de acertos`
                                                      }, [
                                                        _createElementVNode("title", null, _toDisplayString(item.name) + " — média " + _toDisplayString(_ctx.formatPct(item.avg)) + " · " + _toDisplayString(item.correct) + " de " + _toDisplayString(item.total) + " respostas certas em " + _toDisplayString(item.count) + " tentativa(s)", 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donutSegments(item.avg), (seg) => {
                                                          return (_openBlock(), _createElementBlock("circle", {
                                                            key: seg.kind,
                                                            cx: "50",
                                                            cy: "50",
                                                            r: _ctx.DONUT_R,
                                                            fill: "none",
                                                            "stroke-width": "12",
                                                            class: _normalizeClass(seg.kind === 'value' ? 'donut-value' : 'donut-rest'),
                                                            "stroke-dasharray": seg.dash,
                                                            "stroke-dashoffset": seg.offset,
                                                            transform: "rotate(-90 50 50)"
                                                          }, null, 10, _hoisted_152))
                                                        }), 128)),
                                                        _createElementVNode("text", _hoisted_153, _toDisplayString(_ctx.formatPct(item.avg)), 1),
                                                        _cache[92] || (_cache[92] = _createElementVNode("text", {
                                                          x: "50",
                                                          y: "62",
                                                          "text-anchor": "middle",
                                                          class: "donut-sub"
                                                        }, "acertos", -1))
                                                      ], 8, _hoisted_151)),
                                                      _createElementVNode("figcaption", null, [
                                                        _createElementVNode("span", _hoisted_154, _toDisplayString(item.name), 1),
                                                        _createElementVNode("span", _hoisted_155, _toDisplayString(item.count) + " tentativa" + _toDisplayString(item.count === 1 ? '' : 's') + " · " + _toDisplayString(item.correct) + "/" + _toDisplayString(item.total) + " certas", 1)
                                                      ])
                                                    ], 2))
                                                  }), 128))
                                                ]),
                                                _cache[94] || (_cache[94] = _createElementVNode("div", { class: "donut-legend" }, [
                                                  _createElementVNode("span", null, [
                                                    _createElementVNode("i", { class: "lg lg--good" }),
                                                    _createTextVNode("Acertos (média)")
                                                  ]),
                                                  _createElementVNode("span", null, [
                                                    _createElementVNode("i", { class: "lg lg--rest" }),
                                                    _createTextVNode("Erros")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_156, [
                                                  _createElementVNode("table", _hoisted_157, [
                                                    _cache[93] || (_cache[93] = _createElementVNode("thead", null, [
                                                      _createElementVNode("tr", null, [
                                                        _createElementVNode("th", null, "Categoria"),
                                                        _createElementVNode("th", { class: "num" }, "Tentativas"),
                                                        _createElementVNode("th", { class: "num" }, "Média"),
                                                        _createElementVNode("th", { class: "num" }, "Menor"),
                                                        _createElementVNode("th", { class: "num" }, "Maior"),
                                                        _createElementVNode("th", { class: "num" }, "Respostas certas")
                                                      ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donutItems, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: item.key,
                                                          class: _normalizeClass({ 'row-strong': item.overall })
                                                        }, [
                                                          _createElementVNode("td", null, _toDisplayString(item.name), 1),
                                                          _createElementVNode("td", _hoisted_158, _toDisplayString(item.count), 1),
                                                          _createElementVNode("td", _hoisted_159, [
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass(["pct-pill", _ctx.pctTone(item.avg)])
                                                            }, _toDisplayString(_ctx.formatPct(item.avg)), 3)
                                                          ]),
                                                          _createElementVNode("td", _hoisted_160, _toDisplayString(_ctx.formatPct(item.min)), 1),
                                                          _createElementVNode("td", _hoisted_161, _toDisplayString(_ctx.formatPct(item.max)), 1),
                                                          _createElementVNode("td", _hoisted_162, _toDisplayString(item.correct) + "/" + _toDisplayString(item.total), 1)
                                                        ], 2))
                                                      }), 128))
                                                    ])
                                                  ])
                                                ])
                                              ], 64))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                                _createElementVNode("table", _hoisted_164, [
                                                  _cache[98] || (_cache[98] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                      _createElementVNode("th", null, "Usuário"),
                                                      _createElementVNode("th", null, "Dispositivo"),
                                                      _createElementVNode("th", null, "Origem"),
                                                      _createElementVNode("th", null, "Enviado em"),
                                                      _createElementVNode("th", { class: "num" }, "Acertos"),
                                                      _createElementVNode("th", { class: "num" }, "%")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAttempts, (a) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                        key: a.id
                                                      }, [
                                                        _createElementVNode("tr", {
                                                          class: _normalizeClass(["att-row", { open: _ctx.openAttemptId === a.id }]),
                                                          onClick: ($event: any) => (_ctx.toggleAttempt(a.id))
                                                        }, [
                                                          _createElementVNode("td", null, [
                                                            _cache[95] || (_cache[95] = _createElementVNode("svg", {
                                                              class: "row-caret",
                                                              width: "10",
                                                              height: "10",
                                                              viewBox: "0 0 24 24",
                                                              fill: "none",
                                                              stroke: "currentColor",
                                                              "stroke-width": "2.6"
                                                            }, [
                                                              _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                                                            ], -1)),
                                                            _createTextVNode(" " + _toDisplayString(a.participantName), 1)
                                                          ]),
                                                          _createElementVNode("td", null, [
                                                            (a.deviceId)
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 0,
                                                                  class: _normalizeClass(["device-chip", { 'device-chip--shared': _ctx.sharedDeviceIds.has(a.deviceId) }]),
                                                                  type: "button",
                                                                  title: _ctx.deviceTooltip(a),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.filters.device = a.deviceId), ["stop"])
                                                                }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.deviceLabel(a.deviceId)) + " ", 1),
                                                                  (_ctx.sharedDeviceIds.has(a.deviceId))
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createTextVNode(" · " + _toDisplayString(_ctx.deviceNameCount(a.deviceId)) + " nomes", 1)
                                                                      ], 64))
                                                                    : _createCommentVNode("", true)
                                                                ], 10, _hoisted_166))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_167, "—"))
                                                          ]),
                                                          _createElementVNode("td", null, [
                                                            _createElementVNode("span", _hoisted_168, _toDisplayString(a.source === 'public' ? 'Link público' : 'Interno'), 1)
                                                          ]),
                                                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(a.submittedAt)), 1),
                                                          _createElementVNode("td", _hoisted_169, _toDisplayString(a.correctCount) + "/" + _toDisplayString(a.totalCount), 1),
                                                          _createElementVNode("td", _hoisted_170, [
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass(["pct-pill", _ctx.pctTone(a.scorePercent)])
                                                            }, _toDisplayString(_ctx.formatPct(a.scorePercent)), 3)
                                                          ])
                                                        ], 10, _hoisted_165),
                                                        (_ctx.openAttemptId === a.id)
                                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_171, [
                                                              _createElementVNode("td", _hoisted_172, [
                                                                (_ctx.sharedDeviceIds.has(a.deviceId))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_173, " Mesmo dispositivo usado por: " + _toDisplayString(_ctx.otherNamesOnDevice(a).join(', ')), 1))
                                                                  : _createCommentVNode("", true),
                                                                (a.categoryScores && a.categoryScores.length > 1)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.categoryScores, (cs) => {
                                                                        return (_openBlock(), _createElementBlock("span", {
                                                                          key: cs.categoryId || cs.name,
                                                                          class: "att-cat-chip"
                                                                        }, [
                                                                          _createTextVNode(_toDisplayString(cs.name) + " ", 1),
                                                                          _createElementVNode("strong", {
                                                                            class: _normalizeClass(_ctx.pctTone(cs.scorePercent))
                                                                          }, _toDisplayString(_ctx.formatPct(cs.scorePercent)), 3),
                                                                          _cache[96] || (_cache[96] = _createTextVNode()),
                                                                          _createElementVNode("span", _hoisted_175, _toDisplayString(cs.correctCount) + "/" + _toDisplayString(cs.totalCount), 1)
                                                                        ]))
                                                                      }), 128))
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (_ctx.attemptDetailLoading)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_176, "Carregando respostas..."))
                                                                  : (_ctx.attemptDetail)
                                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.attemptGroups, (group) => {
                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                          key: group.key,
                                                                          class: "att-group"
                                                                        }, [
                                                                          (_ctx.attemptGroups.length > 1)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_177, _toDisplayString(group.name), 1))
                                                                            : _createCommentVNode("", true),
                                                                          _createElementVNode("ol", _hoisted_178, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (r) => {
                                                                              return (_openBlock(), _createElementBlock("li", {
                                                                                key: r.questionId,
                                                                                class: _normalizeClass(r.isCorrect ? 'ok' : 'err')
                                                                              }, [
                                                                                _createElementVNode("div", _hoisted_179, _toDisplayString(r.text), 1),
                                                                                _createElementVNode("div", _hoisted_180, [
                                                                                  _createElementVNode("span", _hoisted_181, _toDisplayString(r.isCorrect ? '✓' : '✗'), 1),
                                                                                  _cache[97] || (_cache[97] = _createTextVNode(" Resposta: ", -1)),
                                                                                  _createElementVNode("strong", null, _toDisplayString(r.selectedIndex === null ? 'sem resposta' : `${_ctx.letter(r.selectedIndex)}) ${r.options[r.selectedIndex]}`), 1),
                                                                                  (!r.isCorrect && r.correctIndex !== undefined)
                                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                        _createTextVNode(" · Correta: " + _toDisplayString(_ctx.letter(r.correctIndex)) + ") " + _toDisplayString(r.options[r.correctIndex]), 1)
                                                                                      ], 64))
                                                                                    : _createCommentVNode("", true)
                                                                                ])
                                                                              ], 2))
                                                                            }), 128))
                                                                          ])
                                                                        ]))
                                                                      }), 128))
                                                                    : _createCommentVNode("", true)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  ])
                                                ])
                                              ]))
                                        ], 64))
                              ]))
                      ]),
                      (_ctx.detailTab !== 'resultados')
                        ? (_openBlock(), _createElementBlock("aside", _hoisted_182, [
                            _createElementVNode("div", _hoisted_183, [
                              _cache[99] || (_cache[99] = _createElementVNode("span", { class: "aside-eyebrow" }, "Questionário", -1)),
                              _createElementVNode("h3", _hoisted_184, _toDisplayString(_ctx.editForm.title || 'Sem título'), 1),
                              (_ctx.editForm.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_185, _toDisplayString(_ctx.editForm.description), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_186, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["vis-chip", _ctx.detail.visibility === 'public' ? 'vis-chip--public' : 'vis-chip--private'])
                                }, _toDisplayString(_ctx.detail.visibility === 'public' ? 'Público' : 'Fechado'), 3),
                                _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.perAttemptCount) + " por tentativa", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_188, [
                              _createElementVNode("div", _hoisted_189, [
                                _createElementVNode("div", _hoisted_190, [
                                  _createElementVNode("span", _hoisted_191, _toDisplayString(_ctx.totalQuestions), 1),
                                  _createElementVNode("span", _hoisted_192, "Pergunta" + _toDisplayString(_ctx.totalQuestions === 1 ? '' : 's'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_193, [
                                  _createElementVNode("span", _hoisted_194, _toDisplayString(_ctx.editForm.categories.length), 1),
                                  _createElementVNode("span", _hoisted_195, "Categoria" + _toDisplayString(_ctx.editForm.categories.length === 1 ? '' : 's'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_196, [
                                  _createElementVNode("span", _hoisted_197, _toDisplayString(_ctx.attempts.length), 1),
                                  _createElementVNode("span", _hoisted_198, "Tentativa" + _toDisplayString(_ctx.attempts.length === 1 ? '' : 's'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_199, [
                                  _createElementVNode("span", _hoisted_200, _toDisplayString(_ctx.attempts.length ? _ctx.formatPct(_ctx.overallAvg) : '—'), 1),
                                  _cache[100] || (_cache[100] = _createElementVNode("span", { class: "aside-metric-label" }, "Média", -1))
                                ])
                              ]),
                              (_ctx.totalQuestions)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                    _createElementVNode("div", _hoisted_202, [
                                      _cache[101] || (_cache[101] = _createElementVNode("span", null, "Perguntas completas", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.completeCount) + "/" + _toDisplayString(_ctx.totalQuestions), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_203, [
                                      _createElementVNode("div", {
                                        class: "aside-bar-fill",
                                        style: _normalizeStyle({ width: _ctx.completePct + '%' })
                                      }, null, 4)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.totalQuestions)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                  _cache[102] || (_cache[102] = _createElementVNode("div", { class: "aside-section-title" }, "Navegar pelas perguntas", -1)),
                                  _createElementVNode("div", _hoisted_205, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.categories, (cat) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: cat.key,
                                        class: "q-nav-group"
                                      }, [
                                        _createElementVNode("button", {
                                          class: "q-nav-cat",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.goToCategory(cat))
                                        }, _toDisplayString(cat.name || 'Sem nome'), 9, _hoisted_206),
                                        (cat.questions.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.questions, (q, qi) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                  key: q.key,
                                                  type: "button",
                                                  class: _normalizeClass(["q-nav-dot", _ctx.questionIssue(q) ? 'q-nav-dot--todo' : 'q-nav-dot--ok']),
                                                  title: _ctx.questionIssue(q) || `Pergunta ${qi + 1}`,
                                                  onClick: ($event: any) => (_ctx.goToQuestion(cat, q.key))
                                                }, _toDisplayString(qi + 1), 11, _hoisted_208))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_209, "sem perguntas"))
                                      ]))
                                    }), 128))
                                  ]),
                                  _cache[103] || (_cache[103] = _createElementVNode("div", { class: "q-nav-legend" }, [
                                    _createElementVNode("span", null, [
                                      _createElementVNode("i", { class: "lg lg--ok" }),
                                      _createTextVNode("Completa")
                                    ]),
                                    _createElementVNode("span", null, [
                                      _createElementVNode("i", { class: "lg lg--todo" }),
                                      _createTextVNode("Pendente")
                                    ])
                                  ], -1))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_210, [
                              _createElementVNode("div", _hoisted_211, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["status-dot", 'status-dot--' + _ctx.saveState])
                                }, null, 2),
                                _createElementVNode("span", null, _toDisplayString(_ctx.saveStatusText), 1)
                              ]),
                              (_ctx.detail.visibility === 'public' && _ctx.detail.publicHash)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                    _createElementVNode("button", {
                                      class: "btn-link",
                                      type: "button",
                                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.copyLink(_ctx.detail.publicHash)))
                                    }, _toDisplayString(_ctx.copiedHash === _ctx.detail.publicHash ? 'Link copiado!' : 'Copiar link público'), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ], 64))
                : _createCommentVNode("", true)
          ], 64))
        : (_ctx.view === 'take')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("button", {
                class: "back-link",
                type: "button",
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.exitTake && _ctx.exitTake(...args)))
              }, [...(_cache[104] || (_cache[104] = [
                _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.4"
                }, [
                  _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                ], -1),
                _createTextVNode(" Sair do questionário ", -1)
              ]))]),
              (_ctx.takeLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_213, "Preparando questionário..."))
                : (_ctx.takeError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_214, _toDisplayString(_ctx.takeError), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_215, [
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("h2", _hoisted_217, _toDisplayString(_ctx.take.title), 1),
                        (_ctx.take.description && !_ctx.take.result)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_218, _toDisplayString(_ctx.take.description), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_QuizRunner, {
                        categories: _ctx.take.categories,
                        "current-index": _ctx.take.currentIndex,
                        result: _ctx.take.result,
                        submitting: _ctx.takeSubmitting,
                        "participant-name": _ctx.take.participantName,
                        onSubmitCategory: _ctx.submitTakeCategory,
                        onRestart: _cache[39] || (_cache[39] = ($event: any) => (_ctx.startTake(_ctx.take.quizId)))
                      }, null, 8, ["categories", "current-index", "result", "submitting", "participant-name", "onSubmitCategory"])
                    ]))
            ], 64))
          : _createCommentVNode("", true)
  ]))
}